import React from "react";
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import { Box, ListItemButton, ListItemText } from "@mui/material";

interface ExpandButtonProps {
    onClick: () => void;
    value: any;
    isOpen: boolean;
}

export const ExpandButton = ({
  onClick,
  value,
  isOpen
}: ExpandButtonProps ) => {
  return (
    <ListItemButton
      onClick={onClick}
      sx={{
        alignItems: "center",
        height: '56px',
        border: 'none',
        '&:hover': {
          backgroundColor: 'white'
        },
      }}
      disableRipple
    >
      <ListItemText
        primary={value?.title ? value?.title : "Select service"}
        sx={{
          color: value?.id ? 'black' : '#828282',
        }}
      />
      <Box sx={{
        display: "flex",
        alignItems: "center",
      }}
      >
        {
          isOpen ? null : <KeyboardArrowDownIcon sx={{
            color: '#828282',
          }}/>
        }
      </Box>
    </ListItemButton>
  )
}